import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ColFilter, Tag } from '../../filter.class';
import { LocalTable } from '../../table.class';
import { Col } from '../../../../cols/col.class';
import { Grow } from '../../../../../../animations/animations';
import { ISearcher, SearchMode } from '../../../../../../components/searcher/searcher.component';

@Component({
   selector: 'app-col-control-local',
   template: `
      <app-col-control [col]="col" [ctx]="ctx" (onVisibility)="ctx.filter.filterAll()"></app-col-control>
      <app-searcher [ctx]="searcher"></app-searcher>
      <div class="tags">
         <app-tag *ngFor="let tag of filter.tags" 
                  [tag]="tag" 
                  [disabled]="!col.isVisible" 
                  (onDelete)="filter.delete($event)"
                  (onModeChange)="modeChange($event)"
                  @Grow></app-tag>
      </div>
   `,
   styleUrls: ['./col-control.component.scss'],
   animations: [ Grow ]
})
export class ColControlLocalComponent implements OnInit, OnDestroy {
   @Input() col: Col<object>;
   @Input() filter: ColFilter<object>;
   @Input() ctx: LocalTable<any>;
   public searcher: ISearcher<object>;
   public tags: Set<Tag>;

   constructor() { }

   ngOnInit() {
      this.filter.searcher.init();
      this.searcher = {
         ...this.filter.searcher.ctx,
         style: 'default',
      }
   }

   ngOnDestroy() {
      this.filter.searcher.destroy();
   }

   modeChange(mode: SearchMode) {
      this.ctx.filter.filterAll();
   }

}
